export const tempBillingRedirectRouteLinks = {
    root: "/temp-billing-redirect",
    instance: (shortId: string) => ({
        root: `/temp-billing-redirect/${shortId}`,
    })
};